import { Pipe, PipeTransform } from "@angular/core";
import { Environment } from "src/app/services/env/env.service";

@Pipe({ name: "releasify" })
export class ReleasifyPipe implements PipeTransform {
  public transform(environment: Environment): string {
    return `${environment?.name} v${environment?.release.split("#").join(" b")}`;
  }
}
